/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.wireframe-container-course {
  display: flex;
  flex-direction: row;
  gap: variables.$gap-grid;

  #card-trends {
    min-width: 700px;
    max-width: calc(100% - 450px - 20px);
    width: auto;
  }

  #card-oxygen-trend {
    width: 450px;
  }
}

@media only screen and (max-width: 1910px) {
  .wireframe-container-course {
    flex-direction: column;
    #card-trends {
      max-width: 100%;
      @include mixins.use-available-space;
    }
    #card-oxygen-trend {
      @include mixins.use-available-space;
    }
  }
}
